import { styled, makeStyles, Theme } from '@material-ui/core'
import { LoaderSize } from 'shared/types'

export const BASE_SPINNER_SIZE = 80
export const BASE_SPINNER_WIDTH = 22
export const TINY_SPINNER_WIDTH = 2

const SMALL_SPINNER_MODIFIER = 0.5
const TINY_SPINNER_MODIFIER = 0.13
const BIG_SPINNER_MODIFIER = 1.5

const PULSATE = 'pulsate'

export const getAnimationName = (animationName: string, size: LoaderSize) =>
  `${animationName}-${size}`

export const generateKeyframes = (animationName: string, baseSize: number) => {
  const variants: LoaderSize[] = ['small', 'medium', 'big', 'tiny']
  return variants.reduce((prev, next) => {
    const size =
      next === 'small'
        ? baseSize * SMALL_SPINNER_MODIFIER
        : next === 'big'
        ? baseSize * BIG_SPINNER_MODIFIER
        : next === 'tiny'
        ? baseSize * TINY_SPINNER_MODIFIER
        : baseSize

    return {
      ...prev,
      [`@keyframes ${getAnimationName(animationName, next)}`]: {
        '0%': {
          width: size,
          height: size,
        },
        '50%': {
          width: size * 1.4,
          height: size * 1.4,
          opacity: 0.4,
        },
        '100%': {
          width: size,
          height: size,
        },
      },
    }
  }, {})
}

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
})

export const useStyles = makeStyles<Theme, { size: LoaderSize }>(theme => ({
  ...generateKeyframes('pulsate', BASE_SPINNER_SIZE),
  spinner: {
    borderRadius: '100%',
    boxSizing: 'content-box',
    borderStyle: 'solid',
    borderWidth: ({ size }) =>
      size === 'tiny' ? TINY_SPINNER_WIDTH : BASE_SPINNER_WIDTH,
    borderColor: theme.palette.primary.main,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    animationIterationCount: 'infinite',
    animationDuration: '1300ms',
  },
  small: {
    animationName: `$${getAnimationName(PULSATE, 'small')}`,
  },
  big: {
    animationName: `$${getAnimationName(PULSATE, 'big')}`,
  },
  medium: {
    animationName: `$${getAnimationName(PULSATE, 'medium')}`,
  },
  tiny: {
    animationName: `$${getAnimationName(PULSATE, 'tiny')}`,
  },
}))
